import { useEffect } from "react";

const SITE_NAME = "Ocean Beach Brands";
const DEFAULT_IMAGE = "https://oceanbeachbrands.com/product-images/leonis-blend-hero-optimized.jpg";

const setMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const setLink = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("link");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

export default function SEO({
  title,
  description,
  canonical,
  robots = "index, follow",
  image = DEFAULT_IMAGE,
  type = "website",
}) {
  useEffect(() => {
    document.title = title;

    setMeta('meta[name="title"]', { name: "title", content: title });
    setMeta('meta[name="description"]', { name: "description", content: description });
    setMeta('meta[name="robots"]', { name: "robots", content: robots });
    setMeta('meta[property="og:type"]', { property: "og:type", content: type });
    setMeta('meta[property="og:url"]', { property: "og:url", content: canonical });
    setMeta('meta[property="og:title"]', { property: "og:title", content: title });
    setMeta('meta[property="og:description"]', { property: "og:description", content: description });
    setMeta('meta[property="og:image"]', { property: "og:image", content: image });
    setMeta('meta[property="og:site_name"]', { property: "og:site_name", content: SITE_NAME });
    setMeta('meta[property="twitter:card"]', { property: "twitter:card", content: "summary_large_image" });
    setMeta('meta[property="twitter:url"]', { property: "twitter:url", content: canonical });
    setMeta('meta[property="twitter:title"]', { property: "twitter:title", content: title });
    setMeta('meta[property="twitter:description"]', { property: "twitter:description", content: description });
    setMeta('meta[property="twitter:image"]', { property: "twitter:image", content: image });
    setLink('link[rel="canonical"]', { rel: "canonical", href: canonical });
  }, [canonical, description, image, robots, title, type]);

  return null;
}
